import Vue from 'vue';
import VueRouter from 'vue-router';
// import { DASHBOARD_PERMISSIONS } from '@/constants/permissions';
// import { checkDashboardAccess } from '../utils/permissionHelper';
import { store } from '@/store';
import CompanyWalletDetails from '@/views/dashboard/companies/CompanyWalletDetails.vue';
import CustomerWalletDetails from '@/views/dashboard/customers/CustomerWalletDetails.vue';

const LoginView = () => import('../views/auth/Login.vue');
const MultifactorAuthentication = () => import('../views/auth/MultifactorAuthentication.vue');
const ForgotPassword = () => import('../views/auth/ForgotPassword.vue');
const ResetPassword = () => import('../views/auth/ResetPassword.vue');
const SetPassword = () => import('../views/auth/SetPassword.vue');
const SetupMfa = () => import('../views/auth/SetupMfa.vue');
const EditProfile = () => import('../views/dashboard/EditProfile.vue');
const ChangePassword = () => import('../views/dashboard/ChangePassword.vue');
const DashboardLayout = () => import('../views/dashboard/DashboardLayout.vue');
const AllStaff = () => import('../views/dashboard/staff/AllStaff.vue');
const AllLoans = () => import('../views/dashboard/loans/AllLoans.vue');
const LoansAwaitingAction = () => import('../views/dashboard/loans/LoansAwaitingAction.vue');
const KongaLoans = () => import('../views/dashboard/loans/KongaLoans.vue');
const ProcessKongaCommissions = () =>
  import('../views/dashboard/loans/ProcessKongaCommissions.vue');
const AllInvestments = () => import('../views/dashboard/investments/AllInvestments.vue');
const InvestmentDetails = () => import('../views/dashboard/investments/InvestmentDetails.vue');
const ChangeInvestmentTerms = () =>
  import('../views/dashboard/investments/ChangeInvestmentTerms.vue');
const AddDepositForInvestment = () => import('../views/dashboard/investments/AddDeposit.vue');
const AddMaturePayoutForInvestment = () =>
  import('../views/dashboard/investments/AddPayout.vue');
const AddInvestmentPreLiquidation = () =>
  import('../views/dashboard/investments/AddInvestmentPreLiquidation.vue');
const AddInvestment = () => import('../views/dashboard/investments/AddInvestment.vue');
const AddInvestmentFromReinvestment = () =>
  import('../views/dashboard/investments/AddInvestmentFromReinvestment.vue');
const AddPayoutForInterest = () =>
  import('../views/dashboard/investments/AddPayoutForInterest.vue');
const AllCompanies = () => import('../views/dashboard/companies/AllCompanies.vue');
const PendingApproval = () => import('../views/dashboard/companies/PendingApproval.vue');
const AllCustomers = () => import('../views/dashboard/customers/AllCustomers.vue');
const CustomersPendingVerification = () =>
  import('../views/dashboard/customers/CustomersPendingVerification.vue');
const StaffGroupList = () => import('../views/dashboard/staff/StaffGroupList.vue');
const AddStaff = () => import('../views/dashboard/staff/AddStaff.vue');
const AllRoles = () => import('../views/dashboard/staff/AllRoles.vue');
const AddRole = () => import('../views/dashboard/staff/AddRole.vue');
const SingleRole = () => import('../views/dashboard/staff/SingleRole.vue');
const RoleSettings = () => import('../views/dashboard/staff/RoleSettings.vue');
const AddCompany = () => import('../views/dashboard/companies/AddCompany.vue');
const AddCustomer = () => import('../views/dashboard/customers/AddCustomer.vue');
const EditCustomer = () => import('../views/dashboard/customers/EditCustomer.vue');
const CompanyProfile = () => import('../views/dashboard/companies/CompanyProfile.vue');
const CompanySettings = () => import('../views/dashboard/companies/CompanySettings.vue');
const ReviewWithdrawal = () => import('../views/dashboard/companies/ReviewWithdrawal.vue');
const InitiateWithdrawal = () => import('../views/dashboard/companies/InitiateWithdrawal.vue');
const CustomerProfile = () => import('../views/dashboard/customers/CustomerProfile.vue');
const SingleStaff = () => import('../views/dashboard/staff/SingleStaff.vue');
const StaffAccountSettings = () => import('../views/dashboard/staff/AccountSettings.vue');
const LoanDetails = () => import('../views/dashboard/loans/LoanDetails.vue');
const LoanTransactionDetails = () =>
  import('../views/dashboard/loans/LoanTransactionDetails.vue');
const PayoutDetails = () => import('../views/dashboard/investments/PayoutDetails.vue');
const LoanRepaymentDetails = () => import('../views/dashboard/loans/LoanRepaymentDetails.vue');
const InvestmentTransactionDetails = () =>
  import('../views/dashboard/investments/TransactionDetails.vue');
const ReviewLoanExtension = () => import('../views/dashboard/loans/ReviewLoanExtension.vue');
const ReviewLoanAmendment = () => import('../views/dashboard/loans/ReviewLoanAmendment.vue');
const LoanRestructure = () => import('../views/dashboard/loans/LoanRestructure.vue');
const AmendLoan = () => import('../views/dashboard/loans/AmendLoan.vue');
const AddDisbursementTransaction = () =>
  import('../views/dashboard/loans/AddDisbursementTransaction.vue');
const AddRepaymentTransaction = () =>
  import('../views/dashboard/loans/AddRepaymentTransaction.vue');
const ReverseRepaymentTransaction = () =>
  import('../views/dashboard/loans/ReverseRepaymentTransaction.vue');
const ReverseDisbursementTransaction = () =>
  import('../views/dashboard/loans/ReverseDisbursementTransaction.vue');
const ChangeLoanSettings = () => import('../views/dashboard/loans/ChangeLoanSettings.vue');
const LPOLoan = () => import('../views/dashboard/loans/ApplyForLoan/LPOLoan.vue');
const IDFLoan = () => import('../views/dashboard/loans/ApplyForLoan/IDFLoan.vue');
const WCLoan = () => import('../views/dashboard/loans/ApplyForLoan/WCLoan.vue');
const LFLoan = () => import('../views/dashboard/loans/ApplyForLoan/LFLoan.vue');
const AddCreditTransaction = () =>
  import('../views/dashboard/companies/AddCreditTransaction.vue');
const AddDebitTransaction = () =>
  import('../views/dashboard/companies/AddDebitTransaction.vue');
const AddPayoutAccount = () =>
  import('../views/dashboard/companies/AddPayoutAccount.vue');
const OtherLoans = () => import('../views/dashboard/loans/OtherLoans.vue');
const DataIntegrityReport = () =>
  import('../views/dashboard/reports/DataIntegrityReport.vue');
const FlwPaymentLogs = () =>
  import('../views/dashboard/payments/FlwPaymentLogs.vue');
const WemaPaymentLogs = () =>
  import('../views/dashboard/payments/WemaPaymentLogs.vue');
const Settlements = () => import('../views/dashboard/payments/Settlements.vue');
const SettlementDetails = () =>
  import('../views/dashboard/payments/SettlementDetails.vue');
const SettlementBreakdownDetails = () =>
  import('../views/dashboard/payments/SettlementBreakdownDetails.vue');
const AllPaymentLogs = () =>
  import('../views/dashboard/payments/AllPaymentLogs.vue');
const WemaFailedLookups = () =>
  import('../views/dashboard/payments/WemaFailedLookups.vue');
const TransactionDetails = () =>
  import('../views/dashboard/payments/TransactionDetails.vue');
const GenerateCompanyStatement = () =>
  import('../views/dashboard/payments/GenerateCompanyStatement.vue');
const OtherLoanDetails = () => import('../views/dashboard/loans/OtherLoanDetails.vue');
const ApproveTransaction = () => import('../views/dashboard/payments/ApproveTransaction.vue');
const PayoutRequests = () => import('../views/dashboard/payments/PayoutRequests.vue');
const EditWCLoanRiskProfile = () =>
  import('../views/dashboard/loans/EditRiskProfile/EditWCLoanRiskProfile.vue');
const EditIDFLoanRiskProfile = () =>
  import('../views/dashboard/loans/EditRiskProfile/EditIDFLoanRiskProfile.vue');
const EditLPOLoanRiskProfile = () =>
  import('../views/dashboard/loans/EditRiskProfile/EditLPOLoanRiskProfile.vue');
const EditLFLoanRiskProfile = () =>
  import('../views/dashboard/loans/EditRiskProfile/EditLFLoanRiskProfile.vue');
const AllPartners = () => import('../views/dashboard/partners/AllPartners.vue');
const AddPartner = () => import('../views/dashboard/partners/AddPartner.vue');
const EditPartner = () => import('../views/dashboard/partners/EditPartner.vue');
const ReviewDomiciliation = () =>
  import('../views/dashboard/partners/ReviewDomiciliation.vue');
const PartnerDetails = () => import('../views/dashboard/partners/PartnerDetails.vue');
const AssetViewer = () => import('../views/assets/AssetViewer.vue');
const AllCorporates = () => import('../views/dashboard/corporates/AllCorporates.vue');
const AddCorporate = () => import('../views/dashboard/corporates/AddCorporate.vue');
const EditCorporate = () => import('../views/dashboard/corporates/EditCorporate.vue');
const MergeProfiles = () => import('../views/dashboard/corporates/MergeProfiles.vue');
const CorporateProfile = () => import('../views/dashboard/corporates/CorporateProfile.vue');
const LoanProducts = () => import('@/views/dashboard/loan-configuration/LoanProducts.vue');
const CreateLoanProduct = () =>
  import('@/views/dashboard/loan-configuration/CreateLoanProduct.vue');
const LoanProductDetail = () =>
  import('@/views/dashboard/loan-configuration/LoanProductDetail.vue');
const EditLoanProduct = () =>
  import('@/views/dashboard/loan-configuration/EditLoanProduct.vue');
const ActivateLoanProduct = () =>
  import('@/views/dashboard/loan-configuration/ActivateLoanProduct.vue');
const ApprovalWorkflows = () =>
  import('@/views/dashboard/loan-configuration/ApprovalWorkflows.vue');
const AddApprovalWorkflow = () =>
  import('@/views/dashboard/loan-configuration/AddApprovalWorkflow.vue');
const ViewApprovalWorkflow = () =>
  import('@/views/dashboard/loan-configuration/ViewApprovalWorkflow.vue');
const EditApprovalWorkflow = () =>
  import('@/views/dashboard/loan-configuration/EditApprovalWorkflow.vue');
const CreditPolicies = () => import('@/views/dashboard/loan-configuration/CreditPolicies.vue');
const AddCreditPolicy = () =>
  import('@/views/dashboard/loan-configuration/AddCreditPolicy.vue');
const ViewCreditPolicy = () =>
  import('@/views/dashboard/loan-configuration/ViewCreditPolicy.vue');
const EditCreditPolicy = () =>
  import('@/views/dashboard/loan-configuration/EditCreditPolicy.vue');
const Parameters = () => import('@/views/dashboard/loan-configuration/Parameters.vue');
const CreditPolicyAnalysis = () => import('@/views/dashboard/loans/CreditPolicyAnalysis.vue');
const EditCreditPolicyAnalysis = () =>
  import('@/views/dashboard/loans/EditCreditPolicyAnalysis.vue');
const BankStatementAnalysis = () =>
  import('@/views/dashboard/loans/BankStatementAnalysis.vue');
const InternalDbAnalysis = () => import('@/views/dashboard/loans/InternalDbAnalysis.vue');
const ChecksPendingApproval = () =>
  import('../views/dashboard/checks/ChecksPendingApproval.vue');
const RequestedChecks = () => import('../views/dashboard/checks/RequestedChecks.vue');
const CheckDetails = () => import('../views/dashboard/checks/CheckDetails.vue');
const CheckItemDetails = () => import('../views/dashboard/checks/CheckItemDetails.vue');

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
  },
  {
    path: '/login/mfa',
    name: 'MultifactorAuthentication',
    component: MultifactorAuthentication,
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
  },
  {
    path: '/set-password',
    name: 'SetPassword',
    component: SetPassword,
  },
  {
    path: '/setup-mfa',
    name: 'SetupMfa',
    component: SetupMfa,
  },
  {
    path: '/dashboard',
    component: DashboardLayout,
    children: [
      {
        path: '/dashboard',
        name: 'Home',
        component: () => import('@/views/dashboard/HomeView.vue'),
      },
      {
        path: '/global',
        name: 'GlobalDashboard',
        component: () => import('@/views/dashboard/GlobalDashboardView.vue'),
      },
      {
        path: '/user-funnel',
        name: 'UserFunnel',
        component: () => import('@/views/dashboard/UserFunnelView.vue'),
      },
      {
        path: '/compliance-dashboard',
        name: 'ComplianceDashboard',
        component: () => import('@/views/dashboard/ComplianceDashboard.vue'),
      },
      {
        path: '/unauthorized',
        name: 'Unauthorized',
        component: () => import('@/views/Unauthorized.vue'),
      },
      {
        path: '/edit-profile',
        name: 'EditProfile',
        component: EditProfile,
      },
      {
        path: '/change-password',
        name: 'ChangePassword',
        component: ChangePassword,
      },

      {
        path: '/all-loans',
        name: 'AllLoans',
        component: AllLoans,
      },
      {
        path: '/loans-awaiting-action',
        name: 'LoansAwaitingAction',
        component: LoansAwaitingAction,
      },
      {
        path: '/konga-loans',
        name: 'KongaLoans',
        component: KongaLoans,
      },
      {
        path: '/process-konga-commissions',
        name: 'ProcessKongaCommissions',
        component: ProcessKongaCommissions,
      },
      {
        path: '/all-loans/book-lpo-loan',
        name: 'BookLPOLoan',
        component: LPOLoan,
      },
      {
        path: '/all-loans/book-idf-loan',
        name: 'BookIDFLoan',
        component: IDFLoan,
      },
      {
        path: '/all-loans/book-lf-loan',
        name: 'BookLFLoan',
        component: LFLoan,
      },
      {
        path: '/all-loans/book-wc-loan',
        name: 'BookWCLoan',
        component: WCLoan,
      },
      {
        path: '/all-loans/:id',
        name: 'LoanDetails',
        component: LoanDetails,
      },
      {
        path: '/all-loans/:id/edit-wc-loan-risk-profile',
        name: 'EditWCLoanRiskProfile',
        component: EditWCLoanRiskProfile,
      },
      {
        path: '/all-loans/:id/edit-idf-loan-risk-profile',
        name: 'EditIDFLoanRiskProfile',
        component: EditIDFLoanRiskProfile,
      },
      {
        path: '/all-loans/:id/edit-lf-loan-risk-profile',
        name: 'EditLFLoanRiskProfile',
        component: EditLFLoanRiskProfile,
      },
      {
        path: '/all-loans/:id/edit-lpo-loan-risk-profile',
        name: 'EditLPOLoanRiskProfile',
        component: EditLPOLoanRiskProfile,
      },
      {
        path: '/all-loans/:id/review-loan-extension/:extensionRequestId',
        name: 'ReviewLoanExtension',
        component: ReviewLoanExtension,
      },
      {
        path: '/all-loans/:id/review-loan-amendment/:amendmentId',
        name: 'ReviewLoanAmendment',
        component: ReviewLoanAmendment,
      },
      {
        path: '/all-loans/:id/loan-restructure',
        name: 'LoanRestructure',
        component: LoanRestructure,
      },
      {
        path: '/all-loans/:id/amend-loan',
        name: 'AmendLoan',
        component: AmendLoan,
      },
      {
        path: '/all-loans/:id/add-disbursement-transaction',
        name: 'AddDisbursementTransaction',
        component: AddDisbursementTransaction,
      },
      {
        path: '/all-loans/:id/add-repayment-transaction',
        name: 'AddRepaymentTransaction',
        component: AddRepaymentTransaction,
      },
      {
        path: '/all-loans/:id/reverse-repayment-transaction',
        name: 'ReverseRepaymentTransaction',
        component: ReverseRepaymentTransaction,
      },
      {
        path: '/all-loans/:id/reverse-disbursement-transaction',
        name: 'ReverseDisbursementTransaction',
        component: ReverseDisbursementTransaction,
      },
      {
        path: '/all-loans/:id/change-loan-settings',
        name: 'ChangeLoanSettings',
        component: ChangeLoanSettings,
      },
      {
        path: '/all-loans/:id/loan-transactions/:loanId',
        name: 'LoanTransactionDetails',
        component: LoanTransactionDetails,
      },
      {
        path: '/all-loans/:id/loan-installments/:loanId',
        name: 'LoanRepaymentDetails',
        component: LoanRepaymentDetails,
      },
      {
        path: '/all-loans/:id/credit-policy-analysis',
        name: 'CreditPolicyAnalysis',
        component: CreditPolicyAnalysis,
      },
      {
        path: '/all-loans/:id/credit-policy-analysis/edit',
        name: 'EditCreditPolicyAnalysis',
        component: EditCreditPolicyAnalysis,
      },
      {
        path: '/all-loans/:id/credit-policy-analysis/edit',
        name: 'EditCreditPolicyAnalysis',
        component: EditCreditPolicyAnalysis,
      },
      {
        path: '/all-loans/:id/internal-db-analysis',
        name: 'InternalDbAnalysis',
        component: InternalDbAnalysis,
      },
      {
        path: '/all-loans/:id/bank-statement-analysis',
        name: 'BankStatementAnalysis',
        component: BankStatementAnalysis,
      },
      {
        path: '/other-loans',
        name: 'OtherLoans',
        component: OtherLoans,
      },
      {
        path: '/other-loans/:id',
        name: 'OtherLoanDetails',
        component: OtherLoanDetails,
      },
      {
        path: '/loan-products',
        name: 'LoanProducts',
        component: LoanProducts,
      },
      {
        path: '/loan-products/create',
        name: 'CreateLoanProduct',
        component: CreateLoanProduct,
      },
      {
        path: '/loan-products/:id',
        name: 'LoanProductDetail',
        component: LoanProductDetail,
      },
      {
        path: '/loan-products/:id/edit',
        name: 'EditLoanProduct',
        component: EditLoanProduct,
      },
      {
        path: '/loan-products/:id/activate',
        name: 'ActivateLoanProduct',
        component: ActivateLoanProduct,
      },
      {
        path: '/approval-workflows',
        name: 'ApprovalWorkflows',
        component: ApprovalWorkflows,
      },
      {
        path: '/approval-workflows/create',
        name: 'AddApprovalWorkflow',
        component: AddApprovalWorkflow,
      },
      {
        path: '/approval-workflows/:id',
        name: 'ViewApprovalWorkflow',
        component: ViewApprovalWorkflow,
      },
      {
        path: '/approval-workflows/:id/edit',
        name: 'EditApprovalWorkflow',
        component: EditApprovalWorkflow,
      },
      {
        path: '/credit-policies',
        name: 'CreditPolicies',
        component: CreditPolicies,
      },
      {
        path: '/credit-policies/create',
        name: 'AddCreditPolicy',
        component: AddCreditPolicy,
      },
      {
        path: '/credit-policies/:id',
        name: 'ViewCreditPolicy',
        component: ViewCreditPolicy,
      },
      {
        path: '/credit-policies/:id/edit',
        name: 'EditCreditPolicy',
        component: EditCreditPolicy,
      },
      {
        path: '/parameters',
        name: 'Parameters',
        component: Parameters,
      },
      {
        path: '/all-investments',
        name: 'AllInvestments',
        component: AllInvestments,
      },
      {
        path: '/all-investments/create',
        name: 'AddInvestment',
        component: AddInvestment,
      },
      {
        path: '/all-investments/ngn-reinvestment',
        name: 'AddNGNInvestmentFromReinvestment',
        component: AddInvestmentFromReinvestment,
        props: { isUSD: false },
      },
      {
        path: '/all-investments/usd-reinvestment',
        name: 'AddUSDInvestmentFromReinvestment',
        component: AddInvestmentFromReinvestment,
        props: { isUSD: true },
      },
      // {
      //   path: '/all-investments/ngn-investment',
      //   name: 'AddNGNInvestment',
      //   component: AddInvestment,
      //   props: { isUSD: false },
      // },
      // {
      //   path: '/all/investments/add-usd-investment',
      //   name: 'AddUSDInvestment',
      //   component: AddInvestment,
      //   props: { isUSD: true },
      // },
      {
        path: '/all-investments/:id/add-deposit',
        name: 'AddNGNDeposit',
        component: AddDepositForInvestment,
        props: { isUSD: false },
      },
      {
        path: '/all-investments/:id/add-deposit',
        name: 'AddUSDDeposit',
        component: AddDepositForInvestment,
        props: { isUSD: true },
      },
      {
        path: '/all-investments/:id/add-payout',
        name: 'AddNGNPayoutForMatureInvestment',
        component: AddMaturePayoutForInvestment,
        props: { isNGN: true },
      },
      {
        path: '/all-investments/:id/add-payout',
        name: 'AddUSDPayoutForMatureInvestment',
        component: AddMaturePayoutForInvestment,
        props: { isNGN: false },
      },
      {
        path: '/all-investments/:id/active/add-payout',
        name: 'AddNGNInvestmentPreLiquidation',
        component: AddInvestmentPreLiquidation,
        props: { isNGN: true },
      },
      {
        path: '/all-investments/:id/active/add-payout',
        name: 'AddUSDInvestmentPreLiquidation',
        component: AddInvestmentPreLiquidation,
        props: { isNGN: false },
      },
      {
        path: '/all-investments/:id/partial/add-payout',
        name: 'AddNGNPayoutForInterest',
        component: AddPayoutForInterest,
        props: { isNGN: true },
      },
      {
        path: '/all-investments/:id/partial/add-payout',
        name: 'AddUSDPayoutForInterest',
        component: AddPayoutForInterest,
        props: { isNGN: false },
      },
      {
        path: '/all-investments/:id/payouts/NGN/:payoutId',
        name: 'NGNPayoutDetails',
        component: PayoutDetails,
      },
      {
        path: '/all-investments/:id/payouts/USD/:payoutId',
        name: 'USDPayoutDetails',
        component: PayoutDetails,
      },
      {
        path: '/all-investments/:investmentId/transactions/:transactionId',
        name: 'InvestmentTransactionDetails',
        component: InvestmentTransactionDetails,
      },
      {
        path: '/all-investments/:id/change-terms',
        name: 'ChangeInvestmentTerms',
        component: ChangeInvestmentTerms,
      },
      {
        path: '/all-investments/:id',
        name: 'InvestmentDetails',
        component: InvestmentDetails,
      },
      {
        path: '/all-staff',
        name: 'AllStaff',
        component: AllStaff,
      },
      {
        path: 'groups',
        name: 'StaffGroupList',
        component: StaffGroupList,
      },

      {
        path: '/all-staff/create',
        name: 'AddStaff',
        component: AddStaff,
      },
      {
        path: '/all-staff/:id',
        name: 'SingleStaff',
        component: SingleStaff,
      },
      {
        path: '/all-staff/:id/account-settings',
        name: 'AccountSettings',
        component: StaffAccountSettings,
      },
      {
        path: '/all-roles',
        name: 'AllRoles',
        component: AllRoles,
      },
      {
        path: '/all-roles/create',
        name: 'AddRole',
        component: AddRole,
      },
      {
        path: '/all-roles/:id',
        name: 'SingleRole',
        component: SingleRole,
      },
      {
        path: '/all-roles/:id/role-settings',
        name: 'RoleSettings',
        component: RoleSettings,
      },
      {
        path: '/all-customers',
        name: 'AllCustomers',
        component: AllCustomers,
      },
      {
        path: '/pending-verification',
        name: 'CustomersPendingVerification',
        component: CustomersPendingVerification,
      },
      {
        path: '/all-customers/create',
        name: 'AddCustomer',
        component: AddCustomer,
      },
      {
        path: '/all-customers/:id',
        name: 'CustomerProfile',
        component: CustomerProfile,
      },
      {
        path: '/all-customers/:id/edit',
        name: 'EditCustomer',
        component: EditCustomer,
      },
      {
        path: '/all-customers/:customerId/wallets/:walletId',
        name: 'CustomerWalletDetails',
        component: CustomerWalletDetails,
      },
      {
        path: '/all-customers/:id/add-credit-transaction/:walletId',
        name: 'CustomerAddCreditTransaction',
        component: AddCreditTransaction,
      },
      {
        path: '/all-customers/:id/add-debit-transaction/:walletId',
        name: 'CustomerAddDebitTransaction',
        component: AddDebitTransaction,
      },
      {
        path: '/all-customers/:id/add-payout-account/:walletId',
        name: 'CustomerAddPayoutAccount',
        component: AddPayoutAccount,
      },
      {
        path: '/all-companies',
        name: 'AllCompanies',
        component: AllCompanies,
      },
      {
        path: '/pending-approval',
        name: 'PendingApproval',
        component: PendingApproval,
      },
      {
        path: '/all-companies/:id',
        name: 'CompanyProfile',
        component: CompanyProfile,
      },
      {
        path: '/all-companies/:companyId/wallets/:walletId',
        name: 'CompanyWalletDetails',
        component: CompanyWalletDetails,
      },
      {
        path: '/all-companies/:companyId/wallets/:walletId/initiate-withdrawal',
        name: 'InitiateWithdrawal',
        component: InitiateWithdrawal,
      },
      {
        path: '/withdrawal/:id/review-withdrawal',
        name: 'ReviewWithdrawal',
        component: ReviewWithdrawal,
      },
      {
        path: 'all-companies/create',
        name: 'AddCompany',
        component: AddCompany,
      },
      {
        path: 'all-companies/:id/company-settings',
        name: 'CompanySettings',
        component: CompanySettings,
      },
      {
        path: 'all-companies/:id/add-credit-transaction/:walletId',
        name: 'AddCreditTransaction',
        component: AddCreditTransaction,
      },
      {
        path: 'all-companies/:id/add-debit-transaction/:walletId',
        name: 'AddDebitTransaction',
        component: AddDebitTransaction,
      },
      {
        path: 'all-companies/:id/add-payout-account/:walletId',
        name: 'AddPayoutAccount',
        component: AddPayoutAccount,
        props: true,
      },
      {
        path: '/all-partners',
        name: 'AllPartners',
        component: AllPartners,
      },
      {
        path: 'all-partners/create',
        name: 'AddPartner',
        component: AddPartner,
      },
      {
        path: '/all-partners/review-domiciliation/:id',
        name: 'ReviewDomiciliation',
        component: ReviewDomiciliation,
      },
      {
        path: 'all-partners/:id/edit',
        name: 'EditPartner',
        component: EditPartner,
      },
      {
        path: '/all-partners/:id',
        name: 'PartnerDetails',
        component: PartnerDetails,
      },

      {
        path: '/assets/:assetPath(.*)',
        name: 'AssetViewer',
        component: AssetViewer,
      },
      {
        path: '/all-corporates',
        name: 'AllCorporates',
        component: AllCorporates,
      },
      {
        path: 'all-corporates/create',
        name: 'AddCorporate',
        component: AddCorporate,
      },
      {
        path: 'all-corporates/:id/edit',
        name: 'EditCorporate',
        component: EditCorporate,
      },
      {
        path: 'all-corporates/:id/merge-profiles/:name?',
        name: 'MergeProfiles',
        component: MergeProfiles,
      },
      {
        path: '/all-corporates/:id',
        name: 'CorporateProfile',
        component: CorporateProfile,
      },
      {
        path: '/all-corporates',
        name: 'AllCorporates',
        component: AllCorporates,
      },
      {
        path: 'all-corporates/create',
        name: 'AddCorporate',
        component: AddCorporate,
      },
      {
        path: 'all-corporates/:id/edit',
        name: 'EditCorporate',
        component: EditCorporate,
      },
      {
        path: 'all-corporates/:id/merge-profiles/:name?',
        name: 'MergeProfiles',
        component: MergeProfiles,
      },
      {
        path: '/all-corporates/:id',
        name: 'CorporateProfile',
        component: CorporateProfile,
      },
      {
        path: '/payments/all-payment-logs',
        name: 'AllPaymentLogs',
        component: AllPaymentLogs,
      },
      {
        path: '/payments/payouts',
        name: 'PayoutRequests',
        component: PayoutRequests,
      },
      {
        path: '/payments/flw-payment-logs',
        name: 'FlwPaymentLogs',
        component: FlwPaymentLogs,
      },
      {
        path: '/payments/wema-payment-logs',
        name: 'WemaPaymentLogs',
        component: WemaPaymentLogs,
      },
      {
        path: '/payments/settlements',
        name: 'Settlements',
        component: Settlements,
      },
      {
        path: '/payments/settlements/:id',
        name: 'SettlementDetails',
        component: SettlementDetails,
      },
      {
        path: '/payments/settlements/:id/breakdown/:itemId',
        name: 'SettlementBreakdownDetails',
        component: SettlementBreakdownDetails,
      },
      {
        path: '/payments/wema-failed-lookups',
        name: 'WemaFailedLookups',
        component: WemaFailedLookups,
      },
      {
        path: '/payments/generate-company-statement',
        name: 'GenerateCompanyStatement',
        component: GenerateCompanyStatement,
      },
      {
        path: '/payments/add-credit-transaction',
        name: 'AddCreditFromPayments',
        component: AddCreditTransaction,
      },
      {
        path: '/payments/add-debit-transaction',
        name: 'AddDebitFromPayments',
        component: AddDebitTransaction,
      },
      {
        path: '/payments/approve-transaction/:transactionId',
        name: 'ApproveTransaction',
        component: ApproveTransaction,
      },
      {
        path: '/payments/logs/:id',
        name: 'TransactionDetails',
        component: TransactionDetails,
      },
      {
        path: '/checks/pending-approval',
        name: 'ChecksPendingApproval',
        component: ChecksPendingApproval,
      },
      {
        path: '/checks/requested',
        name: 'RequestedChecks',
        component: RequestedChecks,
      },
      {
        path: 'checks/:id',
        name: 'CheckDetails',
        component: CheckDetails,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/checks/:itemType/:itemId',
        name: 'CheckItemDetails',
        component: CheckItemDetails,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: '/reports/data-integrity',
        name: 'DataIntegrityReport',
        component: DataIntegrityReport,
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  // First check if route requires authentication
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const isLoggedIn = await store.getters['auth/isLoggedIn'];

    if (!isLoggedIn) {
      next({
        name: 'Login',
        query: { redirect: to.fullPath },
      });
      return;
    }

    const user = await store.getters['auth/currentUser'];

    if (user?.isUsingDefaultPassword && to.name !== 'SetPassword') {
      next({ name: 'SetPassword' });
      return;
    }

    // Then check permissions
    // checkDashboardAccess(to, from, next);
    next();
  } else {
    next();
  }
});

export default router;
